<template>
  <div class="clearfix">
    <!-- 单张图片 -->
    <!-- <a-upload v-if="count === 1" name="avatar" list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
      action="https://www.mocky.io/v2/5cc8019d300000980a055e76" :before-upload="beforeUpload" @change="handleChange">
      <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
      <div v-else>
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">
          上传
        </div>
      </div>
    </a-upload> -->
    <!-- 多图 -->
    <a-upload :disabled="disabled" :file-list="fileList" :list-type="type == 'image' ? 'picture-card' : 'picture'"
              :show-upload-list="true" :headers="headers" :before-upload="beforeUpload" :customRequest="handleChange"
              @change="changeImg"  @preview="handlePreview">
      <!-- 文件、视频类型 -->
      <div v-if="type == 'file'||type == 'video'">
        <a-button> <a-icon type="upload" /> 上传 </a-button>
      </div>
      <div v-if="!disabled &&fileList.length < count">
        <span v-if="type == 'image'">
          <a-icon :type="loading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">
            上传
          </div>
        </span>
      </div>
    </a-upload>
    <!--    <span v-if="value && type == 'file'">-->
    <!--      <br>-->
    <!--      <a :href="value" target="_blank">{{ value }}</a>-->
    <!--    </span>-->
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="flex align-center justify-center">
        <img alt="example" style="width: 80px;height: 80px" v-image-preview  :src="previewImage" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import UploadFileToOSS from '@/utils/upload-file-to-oss.js'
export default {
  name: 'ImageUpload',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    // 上传的文件类型 image图片 file文件
    type: {
      type: String,
      default: 'image'
    },
    fieldName:{
      type: String,
      default: 'path'
    },
    count: {
      type: Number,
      default: 1
    },
    defaultList: {
      type: Array,
      default() {
        return []
      }
    },
  },
  components: {
  },
  created() {
    console.log('created')
    console.log('defaultList', this.defaultList)
    if(this.value) {
      this.fileList = [
        {
          uid: '000021',
          url: this.value,
          cover: ''
        }
      ]
    } else {
      // if(this.count == 1) {
      //   this.fileList = [];
      // } else {
      //
      // }
      // this.fileList = this.defaultList
    }
    // console.log('fileList111', this.fileList)
  },
  mounted() {
    console.log('mounted')
  },
  beforeUpdate() {
    // 修复更新的bug
    if (!this.value) {
      this.fileList = []
    } else {
      if(this.count === 1) {
        this.fileList = [
          {
            uid: '000021',
            url: this.value,
            status: 'done',
          }
        ]
      } else {
        console.log('进来了');
        let urlsData = this.value.split(',');
        this.fileList = [];
        urlsData.forEach((i,idx) => {
          this.fileList.push({
            uid:i,
            url: i,
            path:i,
            status: 'done',
          })
        })
      }

    }
  },
  data() {
    return {
      loading: false,
      open: false,

      uploadImgUrl: process.env.VUE_APP_BASE_API + '/common/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN)
      },
      previewVisible: false,
      previewImage: '',
      fileList: [],
    }
  },
  methods: {
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    beforeUpload(file) {
      // 文件类型(file.type)、大小限制(file.size)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小限制 2MB!')
      }
      return isLt2M
    },
    async handleChange(info) {
      console.log('info上传图片得到的数据', info)
      // if (info.file.status === 'uploading') {
      //   this.loading = true
      //   return
      // }
      // if (info.file.status === 'done') {
      //   if (info.file.response.code !== 200) {
      //     this.$message.error('上传失败' + info.file.response.msg)
      //     this.loading = false
      //     return
      //   }
      //   this.loading = false
      //   // this.$emit('input', info.file.response.url)
      // }
      this.loading = true
      new UploadFileToOSS([info.file], {
        finally: (res) => {
          console.log('上传成功回调', res)
          this.loading = false
          this.fileList = this.fileList.concat(res)
          console.log('fileList', this.fileList);
          if(this.count == 1) {
            this.$emit('change',res[0].path)
          } else {
            this.getImg(this.fileList, this.fieldName);
            // this.$emit('change',this.fileList)
          }
        },
      });
    },
    getImg(info, fieldName) {
      console.log('info23333', info)
      const toChangeForm = {}
      if (info.length === 0) {
        toChangeForm[fieldName] = ''
        toChangeForm[`${fieldName}Arr`] = []
      } else {
        if (toChangeForm[`${fieldName}Count`] === 1) {
          toChangeForm[fieldName] = info[0].url
          toChangeForm[`${fieldName}Arr`] = info
        } else {
          toChangeForm[fieldName] = info
            .map((ele) => {
              return ele.url
            })
            .join(',')
          toChangeForm[`${fieldName}Arr`] = info
        }
      }
      this.$emit('change', { ...this.value, ...toChangeForm })
    },
    changeImg(info) {
      console.log('info', info)
      if (info.file.status === "removed") {
        if (this.count === 1) {
          this.value = "";
          this.fileList = [];
          this.$emit('change',"")
          console.log(this.fileList);
        } else {
          let index = this.fileList.findIndex(ele => ele.uid === info.file.uid)
          this.fileList.splice(index, 1)
        }
        this.$forceUpdate()
      }
    },
    handleCancel() {
      this.previewVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
img {
  width: 128px;
  height: 128px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
